module.exports = __webpack_public_path__ + "14_hair_silver.56e0f86f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/14_hair_silver.png
// module id = 2rkP
// module chunks = 0